import RiskThermometer from './RiskThermometer';

export default RiskThermometer;
